// // import React from "react";
// // import SideMenu from "./SideMenu";
// // import { useSelector } from "react-redux";
// // import { Link } from "react-router-dom";
// // import MetaData from "../layout/MetaData";

// // const UserProfile = () => {
// //   const { user } = useSelector((state) => state.auth);

// //   return (
// //     <>
// //     <MetaData title={"My Profile"} />
// //     <section className="max-w-2xl mx-auto md:justify-around md:flex my-16 px-6 py-12 bg-[#f5f5dc] ">
// //       <SideMenu />
// //       <div   className="flex flex-col md:space-y-6 w-full  md:px-8 mt-8 md:mt-0">
// //         {/* Name */}
// //         <h2 className="text-2xl font-playfair text-amber-700">{user?.name}</h2>

// //         {/* Email */}
// //         <p className="text-sm  text-stone-500 font-sourcesans">{user?.email}</p>

// //         <p className="text-stone-700 mb-2 font-sourcesans mt-8 text-sm max-w-md">
// //           Joined on:{" "}
// //           {new Date(user?.createdAt).toLocaleDateString("en-US", {
// //             year: "numeric",
// //             month: "long",
// //             day: "numeric",
// //           })}
// //         </p>

// //         {/* Actions */}
// //         <div className=" space-x-4">
// //           <Link to="/me/update_profile" className="bg-amber-700 hover:bg-amber-800 text-white text-sm px-4 py-2 rounded-md font-sourcesans focus:outline-none focus:ring-2 focus:ring-amber-600">
// //             Edit Profile
// //           </Link>
// //           <Link to="/me/orders" className="border border-stone-400 text-stone-700 hover:border-stone-600 text-sm px-4 py-2 rounded-md font-sourcesans focus:outline-none">
// //             View Orders
// //           </Link>
// //         </div>
// //       </div>
// //     </section>
// //     </>
// //   );
// // };

// // export default UserProfile;

import React from "react";
import SideMenu from "./SideMenu";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const UserProfile = () => {
  const { user } = useSelector((state) => state.auth);

  const menuItems = [
    { name: "Profile", url: "/me/profile" },
    { name: "Edit Profile", url: "/me/update_profile" },
    { name: "Change Password", url: "/me/update_password" },
    { name: "Orders", url: "/me/orders" },
  ];

  return (
    <>
      <Helmet>
        <title>My Profile</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className="max-w-2xl mx-auto md:flex mt-20 py-11 md:mt-48 px-6  bg-[#f5f3ea] shadow-md rounded-md">
        <SideMenu menuItems={menuItems} />

        <div className="flex flex-col md:space-y-6 w-full md:px-8 mt-8 md:mt-0 bg-white/70 backdrop-blur-sm p-6 rounded-md shadow-inner">
          {/* Name */}
          <h2 className="text-2xl font-playfair text-[#BC3F4A]">
            {user?.name}
          </h2>

          {/* Email */}
          <p className="text-sm text-[#1c1917] font-sourcesans">
            {user?.email}
          </p>

          {/* Joined Date */}
          <p className="text-sm text-[#1c1917] font-sourcesans mt-6">
            Joined on:{" "}
            {new Date(user?.createdAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>

          {/* Actions */}
          <div className="mt-6 flex space-x-4">
            <Link
              to="/me/update_profile"
              className="bg-[#BC3F4A] hover:bg-[#a3323b] text-white text-sm px-4 py-2 rounded-md font-playfair focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition"
            >
              Edit Profile
            </Link>
            <Link
              to="/me/orders"
              className="border border-[#8a4b32]/50 text-[#1c1917] hover:border-[#8a4b32] text-sm px-4 py-2 rounded-md font-sourcesans transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500"
            >
              View Orders
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserProfile;
